import {BasketTotalWithBreakDown, BasketInputItem} from "@irati/types"
import optimisticBasket, {optimisticCashbackBasket} from "./optimisticResponse"

export interface DiscountAndCashback {
  discount: BasketTotalWithBreakDown,
  cashback: BasketTotalWithBreakDown
}

export default async function discountAndCashback(items: BasketInputItem[]): Promise<DiscountAndCashback> {
  const discount = await optimisticBasket(items)
  const cashback = await optimisticCashbackBasket(items)

  return {discount, cashback}
}
